import React from 'react'

import styles from "./styles/TimerNavbar.module.scss"
import { CloseButton } from '../CustomComponent'
import CircularProgress from '../CircularProgress'

export default function TimerNavbar({ isTimer = true, timerSeconds, isCoins = true, coins = 0, onClose }) {
    return (
        <div className={styles.TimerNavbar}>
            <span className={styles.closeButton}><CloseButton onClick={onClose} /></span>
            {!isTimer ? "" : <span className={styles.timerContainer}><CircularProgress seconds={timerSeconds} /></span>}
            {!isCoins ? "" : <span className={styles.coinsContainer}>
                <span className={styles.coin}>{coins}</span>
                <span className={styles.icon}>
                    <img
                        src='/assets/coins.png'
                        alt="Coin Icon"
                        className={styles.image}
                    />
                </span>
            </span>
            }
        </div>
    )
}
